import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../utils/axiosInstance";

export const fetchDropdownOptions = createAsyncThunk(
  "dropdownOptions/fetchDropdownOptions",
  async (type, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const response = await axiosInstance.get(
        `/api/dropdown-options/${type}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      return { type, options: response.data };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTamilValues = createAsyncThunk(
  "dropdowns/fetchTamilValues",
  async (index, { getState, rejectWithValue }) => {
    try {
      const {auth } = getState();
      const response = await axiosInstance.get(
        `/api/dropdown-options/${index}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      return response.data.data; // returns array of dropdown objects
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add a new option
export const addDropdownOption = createAsyncThunk(
  "dropdownOptions/add",
  async ({ type, value, tamilValue }, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const data = { type, value, tamilValue };
      const response = await axiosInstance.post("/api/dropdown-options", data, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      return { type, option: response.data };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Update option by ID
export const updateDropdownOption = createAsyncThunk(
  "dropdownOptions/update",
  async ({ id, type, value, tamilValue }, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const data = { type, value, tamilValue };
      const response = await axiosInstance.put(
        `/api/dropdown-options/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      return { id, type, updatedOption: response.data };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Delete option by ID
export const deleteDropdownOption = createAsyncThunk(
  "dropdownOptions/delete",
  async ({ id, type }, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      await axiosInstance.delete(`/api/dropdown-options/${id}`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      return { id, type };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const dropdownOptionsSlice = createSlice({
  name: "dropdownOptions",
  initialState: {
    data: {
      salutation: [],
      paymode: [],
      status: [],
      paypurpose: [],
      utchavam: [],
    },
     tamilValues: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDropdownOptions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDropdownOptions.fulfilled, (state, action) => {
        const { type, options } = action.payload;
        state.data[type] = options;
        state.loading = false;
      })
      .addCase(fetchDropdownOptions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
        .addCase(fetchTamilValues.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTamilValues.fulfilled, (state, action) => {
        state.loading = false;
        state.tamilValues = {};
    //  const { id, tamilValue } = action.payload;
    //     state.tamilValues[id] = tamilValue;
      // Only proceed if we actually got data
  if (Array.isArray(action.payload) && action.payload.length > 0) {
    action.payload.forEach((item) => {
      state.tamilValues[item.id] = item.tamilValue;
    });
  } else {
    console.warn("No Tamil values received.");
  }
      })
      .addCase(fetchTamilValues.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addDropdownOption.fulfilled, (state, action) => {
        const { type, option } = action.payload;
        state.data[type].push(option);
      })

      .addCase(updateDropdownOption.fulfilled, (state, action) => {
        const { id, type, updatedOption } = action.payload;
        const index = state.data[type].findIndex((opt) => opt._id === id);
        if (index !== -1) {
          state.data[type][index] = updatedOption;
        }
      })

      .addCase(deleteDropdownOption.fulfilled, (state, action) => {
        const { id, type } = action.payload;
        state.data[type] = state.data[type].filter((opt) => opt._id !== id);
      });
  },
});

export default dropdownOptionsSlice.reducer;
